import { render, staticRenderFns } from "./ReviewsAnalystComparisonTableCell.vue?vue&type=template&id=0fa58628&scoped=true&"
import script from "./ReviewsAnalystComparisonTableCell.vue?vue&type=script&lang=js&"
export * from "./ReviewsAnalystComparisonTableCell.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAnalystComparisonTableCell.vue?vue&type=style&index=0&id=0fa58628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa58628",
  null
  
)

export default component.exports